import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import {Model} from 'backbone';
import RestService from 'RestService.js';
import listService from 'ListService.js';
import SelectItemModalView from '../common-views/SelectItemModalView.js';
import selectFieldModal from 'common-views/SelectFieldModalView';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import undoService          from 'UndoService.js'
import textConstants            from 'TextConstants';
import userService from 'UserService';
import template from 'common-views/edit-roles.ejs';
import Spinner from 'spin/spin';
import util from 'util/Util';

class EditRolesView extends BasePropertyView {
    initialize(opts) {
        this.options = opts || {};

        this.Spinner = new Spinner();

        this.events = {
            'change input[type=radio]': 'updateModalStatus',
            'change input[name=fixedEmailText]': 'updateEmail',
            'change input[name=name]': 'updateRoleName',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click input[type=button]': 'openModal'
        };

        const row = this.model.get('rowid');
        const gridData = this.model.get('gridData');
        this.roleId = "";

        if (gridData[row]) {
            const rolesModalData = {
                option: gridData[row].userRoleType || 'none',
                label: gridData[row].defaultPerson,
                data: gridData[row].userRoleData,
                id: gridData[row].personId
            };
            this.roleId = gridData[row].id;
            this.model.set('rolesModalData', rolesModalData, { silent: true });
            this.model.set('name', gridData[row].name, { silent: true });
        }
        else{
            this.model.set(data[row], {silent: true});
        }

    }

    setToNone(){
        const rolesModalData={
            option:'none',
            label:'',
            data:{}
        };

        this.model.set('rolesModalData',rolesModalData,{silent:true});
    }

    updateEmail(ev){
        const rolesModalData={
            option:'fixedEmail',
            label: util.sanitizeHTML(ev.currentTarget.value, true, ''),
            data:{}
        };
        this.model.set('rolesModalData',rolesModalData,{silent:true});
    }

    updateRoleName(ev){
        const propName = ev.currentTarget.name;
        const propVal = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        this.model.set(propName, propVal);
    }

    openModal(ev) {
        switch (ev.target.name) {
            case 'userModal':
                    this.displayUsersModal();
                break;
            case 'userGroupModal':
                    this.displayUserGroupsModal();
                break;
            case 'positionModal':
                    this.displayPositionModal();
                break;
            case 'emailValue':
                this.displayValueFieldModal()
                break;
        }
    }

    displayUsersModal(){

        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            RestService.browseAllUsers().then((userData) => {
                let items = userService.mapUsers(userData, constants.USER_TYPE_USER);
                const alertView = new SelectItemModalView({ model: new Model({ items: items, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED }), spinner: this.Spinner });

                alertView.render().then(selectedItemInModal => {
                    if (selectedItemInModal) {
                        let userChosen = {
                            option: 'user',
                            label: selectedItemInModal.label,
                            data: selectedItemInModal.items,
                            id: selectedItemInModal.id
                        };
                        this.model.set('rolesModalData', userChosen, { silent: true });
                        $('#userText').val(selectedItemInModal.label);
                    }
                });
            });
        }, 10);
    }

    displayUserGroupsModal(){
        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            RestService.browseAllUsers().then((userGroupsResponse) => {
                let items = userService.mapUsers(userGroupsResponse, constants.USER_TYPE_GROUP);
                const alertView = new SelectItemModalView({ model: new Model({ items: items, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED }), spinner: this.Spinner });

                alertView.render().then(selectedItemInModal => {
                    if (selectedItemInModal) {
                        let userGroupChosen = {
                            label: selectedItemInModal.label,
                            option: 'userGroup',
                            data: selectedItemInModal.items,
                            id: selectedItemInModal.id
                        };
                        this.model.set('rolesModalData', userGroupChosen, { silent: true });
                        $('#userGroupText').val(selectedItemInModal.label)
                    }
                }).catch(err => console.log(err));
            }).catch(err => console.log(err));
        }, 10);
    }


    displayPositionModal(){

        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            RestService.browseAllUsers().then((positionsResponse) => {
                let items = userService.mapUsers(positionsResponse, constants.USER_TYPE_POSITION);
                const alertView = new SelectItemModalView({ model: new Model({ items: items, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED }), spinner: this.Spinner });

                alertView.render().then(selectedItemInModal => {
                    if (selectedItemInModal) {
                        let positionChosen = {
                            option: 'position',
                            label: selectedItemInModal.label,
                            data: selectedItemInModal.items,
                            id: selectedItemInModal.id
                        };
                        this.model.set('rolesModalData', positionChosen, { silent: true });
                        $('#positionText').val(selectedItemInModal.label);
                    }
                }).catch(err => console.log(err));
            }).catch(err => console.log(err));
        }, 10);
    }

    displayValueFieldModal() {
        var sfModal = new selectFieldModal({model: new Model(), mode: 'insertField'});
        sfModal.render().then((selectedField)=>{
            let fieldChosen = {
                option: 'fieldEmail',
                label: selectedField.name ,
                data: selectedField.id,
                id: selectedField.id
            };
            this.model.set('rolesModalData', fieldChosen,{silent:true});
            $('#fieldEmailText').val(selectedField.name);
        }).catch(err => console.log(err));
    }

    updateModalStatus(ev) {
       this.disableNotRequiredOptions(ev.currentTarget);

       if(ev.currentTarget.value === "none"){
           this.setToNone();
       }
    }

    disableNotRequiredOptions(element){
        let parent = $(element).parent().parent();
        $("#dialog-form").find('.modalEnabled').prop('disabled', true);
        $(parent).find('input.modalEnabled').prop('disabled', false);
    }



    modalToGrid() {
        const row = this.model.get('rowid');
        const data = this.model.get('gridData');
        const rolesModalData = this.model.get('rolesModalData');
        const name = this.model.get('name');

        const newValues = {
            id: this.roleId,
            name: name,
            defaultPerson: rolesModalData.label,
            userRoleData: rolesModalData.data,
            userRoleType:rolesModalData.option,
            personId: rolesModalData.id
        }

        const oldValues = {
            id: this.roleId,
            name: data[row].name,
            defaultPerson: data[row].defaultPerson,
            userRoleData: data[row].userRoleData,
            userRoleType: data[row].userRoleType,
            personId: data[row].personId
        };

        undoService.add({
            undo: () => {
                this.updateGridValues(data, row, oldValues);
            },
            redo: () => {
                this.updateGridValues(data, row, newValues);
            }
        }, textConstants.UNDO_EDIT_ROLE);

        this.updateGridValues(data, row, newValues);
    }

    updateGridValues(data, row, updateValues){
        data[row] = {
            id: updateValues.id,
            name: updateValues.name,
            defaultPerson: updateValues.defaultPerson,
            userRoleData: updateValues.userRoleData,
            userRoleType:updateValues.userRoleType,
            personId: updateValues.personId
        };

        this.model.set({
            gridData: data,
            name: '',
            defaultPerson: '',
            userRoleType: ''
        });

        const _role = listService.getWorkflowRole(this.roleId);
        _role.name = updateValues.name;
        _role.defaultPerson = updateValues.defaultPerson;
        _role.userRoleData = updateValues.userRoleData;
        _role.userRoleType = updateValues.userRoleType;
        _role.personId = updateValues.personId;

        eventBus.trigger(constants.EV_ROLE_OR_STAGE_UPDATED);

        // PF-4862  non-BB listService, doesn't speak BB "eventBus"
        listService.syncNotifyBehaviorRoles();
    }

    render() {
        // Destroying a previous dialog if any.
        if ($("#dialog-form").hasClass('ui-dialog-content')) {
            $('#dialog-form').dialog('destroy').remove();
        }

        this.$el.html(template(this.model.toJSON()));
        $('body').append(this.$el);
        listService.isUndoRedoEnabled = false;

        const self = this;

        $('#dialog-form').dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: 370,
            width: 500,
            modal: true,
            resizable: false,
            buttons: [
                {
                    text: 'OK',
                    'class': 'btn-edit-ok',
                    click: function () {
                        listService.isUndoRedoEnabled = true;
                        $(this).dialog('destroy').remove();
                        self.modalToGrid();
                    }
                },
                {
                    text: 'Cancel',
                    'class': 'btn-edit-cancel',
                    click: function () {
                        listService.isUndoRedoEnabled = true;
                        $(this).dialog('destroy').remove();
                    }
                }
            ]
        });

        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        // Selecting the previously chosen value if any.

        let rolesModalData=this.model.get('rolesModalData');
        let optionAlreadySelected=$("input:radio[value='" + rolesModalData.option + "']");
        optionAlreadySelected.prop('checked',true);

        // Writing values from the model to persist on renders.
        $("input:text[name='" + rolesModalData.option + "Text']").val(rolesModalData.label);
        this.disableNotRequiredOptions(optionAlreadySelected);

        this.$el = $('#dialog-form');
        this.delegateEvents();
        this.$el = $('#content');

        return this;
    }
}
export default EditRolesView;